import { redirect } from '@utils';
import { buildApiUrl } from '../api/build-url';
import { UseParseResultRedirect } from './types';

const useParseResultRedirect: UseParseResultRedirect = ({ transactionId, setError, }) => {
  const handleGetRedirect = async () => {
    try {
      const url = buildApiUrl(`/api/v1/result/${transactionId}/redirect`) + window.location.search;

      const response = await fetch(url, {
        redirect: 'manual'
      });

      if (response.type === 'opaqueredirect') {
        redirect(response.url);
        return true;
      }

      return false;
    } catch (err) {
      console.error(err);
      setError(String(err));
      return false;
    }
  };

  return { onParseResultRedirect: handleGetRedirect };
};

export default useParseResultRedirect;
